import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../utils/api';


export const getSubscriptionEmailDetail =(data,navigate)=> async (dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/subscribe-email`, {
      email: data?.email
    });
    console.log("Log After submit subscriptions___",response);
    
    if(response?.status===201){
     navigate("/");
     toast.success()
      return response?.data;
    }
  } catch (error) {
    console.error("Error:",error);
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     console.log("Registration error:",errorMessage)
     toast.error(errorMessage)
    }
  }
};
 export const refreshToken =  ()=>async(dispatch) => {
  try {
    const refresh= JSON.parse(localStorage.getItem("refreshToken"))
    const refreshToken=refresh?.token;
    const response = await axios.post(`${baseUrl}/auth/refresh-tokens`, {
      refreshToken:refreshToken
    });
    if(response?.status===200||response?.status===201){
      localStorage.setItem("token",JSON.stringify(response?.data?.access)) 
      localStorage.setItem("refreshToken", JSON.stringify(response?.data?.refresh))
    }
    return response;
  } catch (error) {
   
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     
    }
  }
}; 
export const bookAppoinment =  (data)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/book-appointment`, 
      {data}
    );
    if(response?.status===200||response?.status===201){
      toast.success("Booking request sent successfully")
   
    }
    return response;
  } catch (error) {
    console.error("Error:",error);
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     console.log("logut error:",errorMessage)
    }
  }
}; 
export const sendMessage =  (data)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/contact-us`, 
      {data}
    );
    if(response?.status===200||response?.status===201){
      toast.success("Message sent successfully")
   
    }
    return response;
  } catch (error) {
   
    if(error?.response?.data){
     const errorMessage=error.response.data.message
   
    }
  }
}; 